export default __webpack_public_path__ + "static/media/No smoking Icon.214b4fdd.svg";